module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/4866c1d40923145c0fa65053a270b8b6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_unlocked_color.svg
// module id = FXiH
// module chunks = 0